// Copyright (c) Docugami, Inc. All rights reserved.
import { Config } from 'config';
import { useDgAuth } from 'hooks/DgAuthentication';
import { useEffect } from 'react';

export const WordAuthLogoutDialog = () => {
  const { logout } = useDgAuth();
  useEffect(() => {
    logout({ returnTo: `${Config.baseUrl}` });
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  return <div></div>;
};
